export default "__VITE_ASSET__Bh5fz2Xm__"